import {
  Box,
  Typography,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemButton,
} from "@mui/material";

import dayjs from "dayjs";

import { getJobTypeName, getUserPhotoSrc } from "../utils/utils";
import { useSelector } from "react-redux";
import constants from "../static/constants.json";
type MessageListItemProps = {
  job: any;
  selected: boolean;
  onSelect: () => void;
};


const MessageListItem = ({ job, selected, onSelect }: MessageListItemProps) => {
  const user = useSelector((state: any) => state.user);

  const getName = () => {
    if (user.personTypeId === constants.personType.propertyManager) {
      return job.assignee.name;
    } else {
      return job.manager.name;
    }
  };

  const getImagePath = () => {
    if (user.personTypeId === constants.personType.propertyManager) {
      return getUserPhotoSrc(job.assigneeId);
    } else {
      return getUserPhotoSrc(job.managerId);
    }
  };
  return (
    <ListItem
      sx={{
        background: selected ? "#0000000a" : "#ffffff",
      }}
    >
      <ListItemButton
        onClick={() => {
          onSelect();
        }}
      >
        <ListItemAvatar>
          <Avatar alt="u" src={getImagePath()} />
        </ListItemAvatar>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography style={{fontWeight: 700, fontSize: '14px'}}>{getName()}</Typography>
          <Typography variant="caption">
            {getJobTypeName(job.typeId)}
          </Typography>
          <Typography
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1,
            }}
            variant="caption"
          >
            {`${dayjs(job.startTime).format('MMM D h:mm A')} to ${dayjs(job.endTime).format('MMM D h:mm A')}` }
          </Typography>
        </Box>
      </ListItemButton>
    </ListItem>
  );
};

export default MessageListItem;
